module.exports = __webpack_public_path__ + "static/media/logo-sf.271f382e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-sf.png
// module id = 1308
// module chunks = 17